export default {"src":"/_next/static/media/HipDysplasia.ffe47c74.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};